import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["card"]

  connect() {
    this._loaded = false
    this._show = this.show.bind(this)
    this._hide = this.hide.bind(this)
    this.element.addEventListener("mouseenter", this._show)
    this.element.addEventListener("mouseleave", this._hide)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this._show)
    this.element.removeEventListener("mouseleave", this._hide)
  }

  async show() {
    if (!this._loaded) {
      await this.fetchData()
    }
    this.cardTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.cardTarget.classList.remove("opacity-0", "scale-95")
      this.cardTarget.classList.add("opacity-100", "scale-100")
    })
  }

  hide() {
    this.cardTarget.classList.remove("opacity-100", "scale-100")
    this.cardTarget.classList.add("opacity-0", "scale-95")
    setTimeout(() => this.cardTarget.classList.add("hidden"), 150)
  }

  async fetchData() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" }
      })
      if (!response.ok) return
      const data = await response.json()
      this.renderCard(data)
      this._loaded = true
    } catch (_e) {
      // silently ignore
    }
  }

  renderCard(data) {
    const container = this.cardTarget
    container.replaceChildren()

    // Score + Max amount row
    const grid = this.el("div", "grid grid-cols-2 gap-x-4 gap-y-1")

    const scoreBlock = this.el("div")
    scoreBlock.append(this.el("div", "text-xs text-bodydark2", "Score"))
    const scoreColor = data.score >= 70 ? "text-success" : (data.score >= 40 ? "text-warning" : "text-danger")
    scoreBlock.append(this.el("div", `text-sm font-bold ${scoreColor}`, data.score != null ? String(data.score) : "—"))
    grid.append(scoreBlock)

    const amountBlock = this.el("div")
    amountBlock.append(this.el("div", "text-xs text-bodydark2", "Max amount"))
    const amountText = data.max_amount ? `€${Number(data.max_amount).toLocaleString("de-DE")}` : "—"
    amountBlock.append(this.el("div", "text-sm font-semibold text-black dark:text-white", amountText))
    grid.append(amountBlock)

    container.append(grid)

    // Overview
    const overviewSection = this.el("div", "mt-2")
    overviewSection.append(this.el("div", "text-xs text-bodydark2", "Overview"))
    overviewSection.append(this.el("div", "text-xs text-black dark:text-bodydark1 leading-relaxed mt-0.5", data.summary_overview || "—"))
    container.append(overviewSection)

    // Tags
    const tags = (data.tags || []).slice(0, 6)
    if (tags.length > 0) {
      const tagsSection = this.el("div", "mt-2")
      tagsSection.append(this.el("div", "text-xs text-bodydark2 mb-1", "Tags"))
      const tagsWrap = this.el("div", "flex flex-wrap gap-1")
      tags.forEach(t => {
        tagsWrap.append(this.el("span", "inline-block rounded bg-gray-2 dark:bg-meta-4 px-1.5 py-0.5 text-xs text-bodydark dark:text-bodydark1", t))
      })
      tagsSection.append(tagsWrap)
      container.append(tagsSection)
    }
  }

  el(tag, className, textContent) {
    const element = document.createElement(tag)
    if (className) element.className = className
    if (textContent) element.textContent = textContent
    return element
  }
}
